module.exports = __webpack_public_path__ + "img/UFCW_Logo_White.4e8eb7a6.png";